import cn from 'classnames';

import { IConDefaultType } from '..';

export enum LockIconVariant {
  DEFAULT = 'default',
  UNLOCK = 'unlock',
  SMALL = 'small',
  FILL = 'fill',
  GALLERY = 'gallery',
}

export interface ILockIconProps extends IConDefaultType {
  variant?: LockIconVariant;
}

function LockIcon({
  color = '#303037',
  className,
  size = 16,
  rotate,
  flip,
  variant = LockIconVariant.DEFAULT,
  style,
}: ILockIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
        ...style,
      }}
    >
      {variant === LockIconVariant.DEFAULT && (
        <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_14600_273408)">
            <path
              d="M12.6673 5.616V4.66667C12.6673 3.42899 12.1757 2.242 11.3005 1.36683C10.4253 0.491665 9.23833 0 8.00065 0C6.76297 0 5.57599 0.491665 4.70082 1.36683C3.82565 2.242 3.33398 3.42899 3.33398 4.66667V5.616C2.74022 5.87514 2.23485 6.30168 1.87965 6.84347C1.52445 7.38527 1.33484 8.01882 1.33398 8.66667V12.6667C1.33504 13.5504 1.68657 14.3976 2.31146 15.0225C2.93636 15.6474 3.78359 15.9989 4.66732 16H11.334C12.2177 15.9989 13.0649 15.6474 13.6898 15.0225C14.3147 14.3976 14.6663 13.5504 14.6673 12.6667V8.66667C14.6665 8.01882 14.4768 7.38527 14.1217 6.84347C13.7665 6.30168 13.2611 5.87514 12.6673 5.616ZM4.66732 4.66667C4.66732 3.78261 5.01851 2.93477 5.64363 2.30964C6.26875 1.68452 7.1166 1.33333 8.00065 1.33333C8.88471 1.33333 9.73255 1.68452 10.3577 2.30964C10.9828 2.93477 11.334 3.78261 11.334 4.66667V5.33333H4.66732V4.66667ZM13.334 12.6667C13.334 13.1971 13.1233 13.7058 12.7482 14.0809C12.3731 14.456 11.8644 14.6667 11.334 14.6667H4.66732C4.13688 14.6667 3.62818 14.456 3.2531 14.0809C2.87803 13.7058 2.66732 13.1971 2.66732 12.6667V8.66667C2.66732 8.13623 2.87803 7.62753 3.2531 7.25245C3.62818 6.87738 4.13688 6.66667 4.66732 6.66667H11.334C11.8644 6.66667 12.3731 6.87738 12.7482 7.25245C13.1233 7.62753 13.334 8.13623 13.334 8.66667V12.6667Z"
              fill={color}
            />
            <path
              d="M8.00065 9.33594C7.82384 9.33594 7.65427 9.40618 7.52925 9.5312C7.40422 9.65622 7.33398 9.82579 7.33398 10.0026V11.3359C7.33398 11.5127 7.40422 11.6823 7.52925 11.8073C7.65427 11.9324 7.82384 12.0026 8.00065 12.0026C8.17747 12.0026 8.34704 11.9324 8.47206 11.8073C8.59709 11.6823 8.66733 11.5127 8.66733 11.3359V10.0026C8.66733 9.82579 8.59709 9.65622 8.47206 9.5312C8.34704 9.40618 8.17747 9.33594 8.00065 9.33594Z"
              fill={color}
            />
          </g>
          <defs>
            <clipPath id="clip0_14600_273408">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )}
      {variant === LockIconVariant.UNLOCK && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 21" fill="none">
          <g clipPath="url(#clip0_66_26940)">
            <path
              d="M14.1668 7.16739H5.83345V6.33406C5.83319 5.41023 6.13997 4.51251 6.70554 3.78204C7.27112 3.05157 8.06342 2.52977 8.95789 2.29869C9.85235 2.06761 10.7982 2.14035 11.6469 2.50546C12.4955 2.87058 13.1987 3.50737 13.6459 4.31573C13.6991 4.41143 13.7705 4.49573 13.8562 4.56381C13.942 4.63189 14.0402 4.68243 14.1455 4.71253C14.2507 4.74263 14.3609 4.75171 14.4696 4.73925C14.5783 4.72679 14.6836 4.69302 14.7793 4.63989C14.875 4.58676 14.9593 4.5153 15.0274 4.42959C15.0954 4.34388 15.146 4.2456 15.1761 4.14036C15.2062 4.03512 15.2153 3.92499 15.2028 3.81624C15.1903 3.70749 15.1566 3.60226 15.1034 3.50656C14.477 2.37516 13.4924 1.48399 12.3043 0.973155C11.1162 0.462317 9.79208 0.360769 8.54 0.684473C7.28793 1.00818 6.17892 1.73878 5.3873 2.76144C4.59568 3.78409 4.16635 5.04082 4.16678 6.33406V7.52073C3.42458 7.84465 2.79286 8.37783 2.34886 9.05507C1.90487 9.73231 1.66784 10.5243 1.66678 11.3341V16.3341C1.6681 17.4387 2.10751 18.4978 2.88863 19.2789C3.66974 20.06 4.72878 20.4994 5.83345 20.5007H14.1668C15.2714 20.4994 16.3305 20.06 17.1116 19.2789C17.8927 18.4978 18.3321 17.4387 18.3334 16.3341V11.3341C18.3321 10.2294 17.8927 9.17036 17.1116 8.38924C16.3305 7.60813 15.2714 7.16872 14.1668 7.16739ZM16.6668 16.3341C16.6668 16.9971 16.4034 17.633 15.9345 18.1018C15.4657 18.5707 14.8298 18.8341 14.1668 18.8341H5.83345C5.1704 18.8341 4.53452 18.5707 4.06568 18.1018C3.59684 17.633 3.33345 16.9971 3.33345 16.3341V11.3341C3.33345 10.671 3.59684 10.0351 4.06568 9.56629C4.53452 9.09745 5.1704 8.83406 5.83345 8.83406H14.1668C14.8298 8.83406 15.4657 9.09745 15.9345 9.56629C16.4034 10.0351 16.6668 10.671 16.6668 11.3341V16.3341Z"
              fill={color}
            />
            <path
              d="M10.0001 12.1672C9.77913 12.1672 9.56717 12.255 9.41089 12.4113C9.25461 12.5675 9.16681 12.7795 9.16681 13.0005V14.6672C9.16681 14.8882 9.25461 15.1001 9.41089 15.2564C9.56717 15.4127 9.77913 15.5005 10.0001 15.5005C10.2212 15.5005 10.4331 15.4127 10.5894 15.2564C10.7457 15.1001 10.8335 14.8882 10.8335 14.6672V13.0005C10.8335 12.7795 10.7457 12.5675 10.5894 12.4113C10.4331 12.255 10.2212 12.1672 10.0001 12.1672Z"
              fill={color}
            />
          </g>
          <defs>
            <clipPath id="clip0_66_26940">
              <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
            </clipPath>
          </defs>
        </svg>
      )}
      {variant === LockIconVariant.SMALL && (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9.5 4.212V3.5C9.5 2.57174 9.13125 1.6815 8.47487 1.02513C7.8185 0.368749 6.92826 0 6 0C5.07174 0 4.1815 0.368749 3.52513 1.02513C2.86875 1.6815 2.5 2.57174 2.5 3.5V4.212C2.05468 4.40635 1.67565 4.72626 1.40925 5.13261C1.14285 5.53895 1.00064 6.01412 1 6.5V9.5C1.00079 10.1628 1.26444 10.7982 1.73311 11.2669C2.20178 11.7356 2.8372 11.9992 3.5 12H8.5C9.1628 11.9992 9.79822 11.7356 10.2669 11.2669C10.7356 10.7982 10.9992 10.1628 11 9.5V6.5C10.9994 6.01412 10.8571 5.53895 10.5908 5.13261C10.3244 4.72626 9.94532 4.40635 9.5 4.212ZM3.5 3.5C3.5 2.83696 3.76339 2.20107 4.23223 1.73223C4.70107 1.26339 5.33696 1 6 1C6.66304 1 7.29893 1.26339 7.76777 1.73223C8.23661 2.20107 8.5 2.83696 8.5 3.5V4H3.5V3.5ZM10 9.5C10 9.89782 9.84196 10.2794 9.56066 10.5607C9.27936 10.842 8.89782 11 8.5 11H3.5C3.10218 11 2.72064 10.842 2.43934 10.5607C2.15804 10.2794 2 9.89782 2 9.5V6.5C2 6.10218 2.15804 5.72064 2.43934 5.43934C2.72064 5.15804 3.10218 5 3.5 5H8.5C8.89782 5 9.27936 5.15804 9.56066 5.43934C9.84196 5.72064 10 6.10218 10 6.5V9.5Z"
            fill={color}
          />
          <path
            d="M6 7C5.86739 7 5.74022 7.05268 5.64645 7.14645C5.55268 7.24021 5.5 7.36739 5.5 7.5V8.5C5.5 8.63261 5.55268 8.75978 5.64645 8.85355C5.74022 8.94732 5.86739 9 6 9C6.13261 9 6.25979 8.94732 6.35356 8.85355C6.44733 8.75978 6.50001 8.63261 6.50001 8.5V7.5C6.50001 7.36739 6.44733 7.24021 6.35356 7.14645C6.25979 7.05268 6.13261 7 6 7Z"
            fill={color}
          />
        </svg>
      )}
      {variant === LockIconVariant.FILL && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 18" fill="none">
          <path
            d="M14.2958 6.5866V5.62539C14.2958 3.01585 12.1804 0.900391 9.5708 0.900391C6.96124 0.900391 4.8458 3.01585 4.8458 5.62539V6.5866C3.61732 7.12275 2.82257 8.33503 2.8208 9.67539V13.7254C2.82302 15.5884 4.33275 17.0982 6.19578 17.1004H12.9458C14.8088 17.0982 16.3186 15.5884 16.3208 13.7254V9.67539C16.3191 8.33503 15.5243 7.12275 14.2958 6.5866ZM10.2458 12.3754C10.2458 12.7482 9.94359 13.0504 9.5708 13.0504C9.19801 13.0504 8.89581 12.7482 8.89581 12.3754V11.0254C8.89581 10.6526 9.19801 10.3504 9.5708 10.3504C9.94359 10.3504 10.2458 10.6526 10.2458 11.0254V12.3754ZM12.9458 6.30041H6.19578V5.62542C6.19578 3.76147 7.70682 2.2504 9.5708 2.2504C11.4348 2.2504 12.9458 3.76144 12.9458 5.62542V6.30041Z"
            fill={color || 'white'}
          />
        </svg>
      )}
      {variant === LockIconVariant.GALLERY && (
        <svg viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.273438" width="24" height="24" rx="12" fill="black" fillOpacity="0.6" />
          <g clipPath="url(#clip0_1389_56776)">
            <path
              d="M16 10.4854V9.77343C16 7.84045 14.433 6.27344 12.5 6.27344C10.567 6.27344 9 7.84045 9 9.77343V10.4854C8.09002 10.8826 7.50131 11.7806 7.5 12.7734V15.7734C7.50164 17.1535 8.61996 18.2718 9.99998 18.2734H15C16.38 18.2718 17.4983 17.1535 17.5 15.7734V12.7734C17.4987 11.7806 16.91 10.8826 16 10.4854ZM13 14.7734C13 15.0496 12.7761 15.2734 12.5 15.2734C12.2239 15.2734 12 15.0496 12 14.7734V13.7734C12 13.4973 12.2239 13.2734 12.5 13.2734C12.7761 13.2734 13 13.4973 13 13.7734V14.7734ZM15 10.2734H9.99998V9.77345C9.99998 8.39275 11.1193 7.27345 12.5 7.27345C13.8807 7.27345 15 8.39273 15 9.77345V10.2734Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1389_56776">
              <rect width="12" height="12" fill="white" transform="translate(6.5 6.27344)" />
            </clipPath>
          </defs>
        </svg>
      )}
    </i>
  );
}

export default LockIcon;
